import React from "react";
import Status from "../../../../model2/status/status";

type Props = {
    className?: string,
    status: Status,
    onCheckboxClick: callback,
    minimized   : boolean
}

export default function TaskStatusSelector_TaskReply(props: Props) {

    if (props.minimized) {
        return (
            <div className="cur-value task-reply-type minimized i5-status-update "/>
        )
    }

    return (
        <div className="cur-value task-reply-type">
            <div className={Classes("name", 'gd-scf-'+props.status.color )}>{props.status.name}</div>
            <div className="arrow-icon i5-big-angle-down"> </div>
        </div>
    )
}
